import { useTranslation } from "react-i18next";
import { Volume2 } from "lucide-react";
import { useTracks } from "@livekit/components-react";
import { Track } from "livekit-client";

/**
 * Says who is sharing sound, for the person listening to it.
 *
 * Screen sharing announces itself — a second tile appears. Sharing only the
 * audio of a tab announces nothing at all: sound simply starts coming out of
 * a picture that has not changed, which reads as someone's speakers being on
 * by accident. This is the only thing on the patient's screen that says
 * otherwise.
 */
export default function MeetingAudioBadge() {
    const { t } = useTranslation();

    const sharers = useTracks([Track.Source.ScreenShareAudio], {
        onlySubscribed: false,
    }).filter(({ participant }) => !participant.isLocal);

    if (sharers.length === 0) return null;

    const [{ participant }] = sharers;

    return (
        <div
            className="pointer-events-none absolute inset-x-0 top-3 flex justify-center"
            data-testid="meeting-audio-share"
        >
            <p
                role="status"
                className="flex items-center gap-2 rounded-full border border-room-line bg-room-base/85 px-3.5 py-1.5 text-xs font-medium text-room-ink-muted backdrop-blur-sm"
            >
                <Volume2 size={13} aria-hidden="true" />
                {t("meetingControls.shareAudioIncoming", {
                    name: participant.name || participant.identity,
                })}
            </p>
        </div>
    );
}
